import React, { useState } from 'react';
import DefaultTemplate from '@components/shared/templates/DefaultTemplate/DefaultTemplate';
import env from '@lib/envs/env';
import { IDesignerProfile } from '@components/pages/DesignerProfile/graphql/designer-profile-query.graphql';
import { IDesignerBoard } from '@components/pages/DesignerProfile/graphql/designer-boards.graphql';
import DesktopVersion from './DesktopVersion/DesktopVersion';
import MobileVersion from './MobileVersion/MobileVersion';
import styles from './DesignerProfile.module.scss';
import { TABS } from './shared/Tabs/Tabs';

interface IDesignerJsonLdSchema {
  '@context': 'http://schema.org/';
  '@type': 'Person';
  familyName: string;
  givenName: string;
  worksFor: 'Havenly';
  workLocation: string;
  jobTitle: 'Interior Designer';
  knowsAbout: 'Interior Design';
  Url: string;
}

interface IDesignerProfileProps {
  designer: IDesignerProfile;
  initialBoards: IDesignerBoard[];
}

const DesignerProfile = ({
  designer,
  initialBoards,
}: IDesignerProfileProps) => {
  const [tab, setTab] = useState<TABS>('portfolio');

  const schemaData: IDesignerJsonLdSchema = {
    '@context': 'http://schema.org/',
    '@type': 'Person',
    familyName: designer.lastName,
    givenName: designer.firstName,
    worksFor: 'Havenly',
    workLocation: designer.location || '',
    jobTitle: 'Interior Designer',
    knowsAbout: 'Interior Design',
    Url: `https://havenly.com${designer.profileUri}`
  };

  return (
    <DefaultTemplate
      canonicalLink={`https://${env.DOMAIN_NAME}${designer.profileUri}`}
      title={getPageTitle(designer)}
      description={designer.designAesthetic}
      jsonSchema={schemaData}
    >
      <div className={styles.Tablet}>
        <DesktopVersion
          designer={designer}
          initialBoards={initialBoards}
          tab={tab}
          setTab={setTab}
        />
      </div>
      <div className={styles.Mobile}>
        <MobileVersion
          designer={designer}
          initialBoards={initialBoards}
          tab={tab}
          setTab={setTab}
        />
      </div>
    </DefaultTemplate>
  );
};

function getPageTitle(designer: IDesignerProfile): string {
  const title = designer.seoTitle || 'Interior Designer';
  const style = designer.favoriteSubStyles?.[0]?.name || 'Midcentury Modern';
  const location = designer.location || 'Denver';
  return `Top ${style} ${title} Near You: ${designer.firstName} ${designer.lastName} (${location}) - Havenly`;
}

export default DesignerProfile;
